import axios from "axios";

export class BaseAPIClient {
  constructor(baseURL = process.env.VUE_APP_PITCH_API) {
    this.instance = axios.create({
      baseURL,
    });

    this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          window.location.href = "/connect";
        }
        return Promise.reject(error);
      }
    );
  }

  async call(path, method, data, additionalHeaders = undefined) {
    return await new Promise((resolve, reject) => {
      const request = {
        url: path,
        method,
        data,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          refreshToken: "Bearer " + localStorage.getItem("refreshToken"),
          ...additionalHeaders,
        },
      };
      if (method === "GET" && data) {
        request.params = data;
      }

      this.instance
        .request(request)
        .then((result) => {
          return resolve(result);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }

  async uploadFiles(formData) {
    return this.call("/avatar", "POST", formData, {
      "Content-Type": "multipart/form-data",
    });
  }
}
